import { setupCountUp } from "@/js/helpers";

// データでみる東宝ハウス新小岩: スクロールインで数値をカウントアップ表示
const recruitData = () => {
    setupCountUp(".pg-recruit-data__num, .pg-recruit-data__sub-num", { delay: 300 });
};

export default recruitData;
